module.exports = "/images/calendar-icon.svg?82321497def8de4d9bbc660642a7ab0a";